module.exports = __webpack_public_path__ + "static/media/YB5F18_8.1ff6e07d.jpg";